export default __webpack_public_path__ + "static/media/Icon8_On.93666361.png";